import { useNavigate } from 'react-router-dom';
import { useCreateJob } from '../../api/jobs';
import JobForm from './JobForm';

export default function NewJob() {
  const navigate = useNavigate();
  const create = useCreateJob();

  return (
    <div className="panel">
      <h2>New job description</h2>
      <JobForm
        submitLabel="Create job"
        pending={create.isPending}
        error={create.error instanceof Error ? create.error.message : null}
        onCancel={() => navigate('/jobs')}
        onSubmit={(values) =>
          create.mutate(values, { onSuccess: (job) => navigate(`/jobs/${job.id}`) })
        }
      />
    </div>
  );
}
